import css from './Notification.module.css'

const Notification = () => {
  return <p className={css.text}>No feedback given</p>;
};

export default Notification;
